import {
  EDITOR_CREATE_PAGE_BEGIN,
  EDITOR_CREATE_PAGE_DISMISS_ERROR,
  EDITOR_CREATE_PAGE_FAILURE,
  EDITOR_CREATE_PAGE_SUCCESS,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { getCookie, updateUserIpInCookie } from '../../home/app_util';

export function createPage(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: EDITOR_CREATE_PAGE_BEGIN,
    });
    const { projectId, version, data } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/pages`,
        data,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: EDITOR_CREATE_PAGE_SUCCESS,
              data: res.data,
            });
            const { uuid, name } = res.data;
            Mixpanel.track('Created Page on builder', { name, uuid });
            toast.success('Created Successfully !');
            resolve(res.data);
          } else {
            dispatch({
              type: EDITOR_CREATE_PAGE_FAILURE,
              data: { error: 'Failed' },
            });
            Mixpanel.track('Create page failed on builder');
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Creation Failed : ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: EDITOR_CREATE_PAGE_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Create page failed on builder');
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Creation Failed : ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreatePageError() {
  return {
    type: EDITOR_CREATE_PAGE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EDITOR_CREATE_PAGE_BEGIN:
      return {
        ...state,
        createPagePending: true,
        createPageError: null,
      };

    case EDITOR_CREATE_PAGE_SUCCESS:
      return {
        ...state,
        createPagePending: false,
        createPageError: null,
        pages: [...state.pages, action.data],
        selectedPage: action.data,
      };

    case EDITOR_CREATE_PAGE_FAILURE:
      return {
        ...state,
        createPagePending: false,
        createPageError: action.data.error,
      };

    case EDITOR_CREATE_PAGE_DISMISS_ERROR:
      return {
        ...state,
        createPageError: null,
      };

    default:
      return state;
  }
}
